module.exports = __webpack_public_path__ + "./Annie_0f3e6be8e4b6a76c8e36c39951513c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Annie.jpg
// module id = 490
// module chunks = 0